// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cXWN","label":"styles_label__2T53r"};